import type { PaymentReceiptView } from '@solar/contracts';

import { Alert } from '../../components/Alert';
import { Button } from '../../components/Button';
import { StatusBadge } from '../../components/StatusBadge';
import { formatNgn } from '../../lib/format-currency';
import styles from '../../pages/app/AppPages.module.css';

function formatTimestamp(value: string | null): string {
  return value === null ? '—' : new Date(value).toLocaleString();
}

export function PaymentReceiptDisplay({ data }: { data: PaymentReceiptView }): React.JSX.Element {
  return (
    <>
      <header className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>Payment receipt</h1>
        <StatusBadge status={data.status} />
        <Button variant="secondary" onClick={() => window.print()}>
          Print / save receipt
        </Button>
      </header>

      {data.identitySource === 'LEGACY_CURRENT_PROFILE' && (
        <Alert tone="warning">
          This legacy receipt predates immutable contract-party snapshots. Its customer name is
          derived from the current profile rather than reconstructed historical evidence.
        </Alert>
      )}

      <section className={styles.card} aria-labelledby="receipt-heading">
        <h2 className={styles.cardTitle} id="receipt-heading">
          {data.companyName}
        </h2>

        <dl className={styles.definitionList}>
          <dt>Receipt number</dt>
          <dd>{data.receiptNumber}</dd>
          <dt>Payment reference</dt>
          <dd>{data.paymentReference}</dd>
          <dt>Customer</dt>
          <dd>{data.customerName}</dd>
          <dt>Contract</dt>
          <dd>{data.contractReference ?? '—'}</dd>
          <dt>Product</dt>
          <dd>{data.productName ?? '—'}</dd>
          <dt>Instalment</dt>
          <dd>#{data.instalmentSequence}</dd>
          <dt>Amount</dt>
          <dd>{formatNgn(data.amount)}</dd>
          <dt>Payment method</dt>
          <dd>{data.paymentMethod}</dd>
          <dt>Bank</dt>
          <dd>{data.bankName ?? '—'}</dd>
          <dt>Account</dt>
          <dd>{data.accountMasked ?? '—'}</dd>
          <dt>Confirmed</dt>
          <dd>{formatTimestamp(data.providerConfirmedAt)}</dd>
          <dt>Posted</dt>
          <dd>{formatTimestamp(data.postedAt)}</dd>
          <dt>Support</dt>
          <dd>
            <a href={`mailto:${data.supportEmail}`}>{data.supportEmail}</a>
          </dd>
        </dl>
      </section>
    </>
  );
}
